module.exports = __webpack_public_path__ + "static/media/Avatars_Other-13.843a3206.png";